import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  //Button,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Nav,
  NavItem,
  NavLink,
  Badge,
} from "reactstrap"
//import MetaTags from "react-meta-tags"
import "./styles.scss"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import classnames from "classnames"

const MyProfile = () => {
  let tabs = [
    {
      id: 1,
      value: "sales",
      label: "Contact Info",
    },
    {
      id: 2,
      value: "event",
      label: "Current Employment",
    },
    {
      id: 3,
      value: "account",
      label: "Maintanance",
    },
    {
      id: 4,
      value: "operations",
      label: "History",
    },
  ]
  const columns = [
    {
      dataField: "",
      text: "Permanent Address",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "Secondary Address",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "",
      text: "Area",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "Home Town",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "Settled In",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "City",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "State",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "Country",
      headerStyle: {
        minWidth: "130px",
      },
    },
  ]
  const column = [
    {
      dataField: "",
      text: "Company",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "",
      text: "Branch",
      headerStyle: {
        minWidth: "130px",
      },
    },
  ]
  const handleChange = async (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value })
  }
  const [customIconActiveTab, setCustomIconActiveTab] = useState(1)
  const [showProfile, setShowProfile] = useState(true)
  const [editprofile,setEditProfile] = useState(false)
  const [Gender, setGender] = useState([])
  
  const [Marital,setMarital] = useState([])
  const [Business,setBusiness] = useState("")
  const [mobile,setMobile] = useState("")
  const [Skype,setSkype] = useState("")
  const [email,setEmail] = useState([])
  const [Employee,setEmployee] = useState([])
  const [Role,setRole] = useState([])
  const [Biometric,setBiometric] = useState([])
  const [Training,setTraining] = useState([])
  const [doj,setDoj] = useState([])
  const [Salery,setSalery] = useState([])
  const [Shift,setShift] = useState([])
  const [profileData, setProfileData] = useState({
    Gender: [],
    maritalStatus: [],
    Alternate: "",
   Business: "",
   mobile: "",
   Skype: "",
   email: "",
   employee: "",
   Role: "",
   Biometric: "",
   Training: "",
   doj: "",
   Salery: "",
   Shift: "",
   
  })
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
              <Card style={{ backgroundAttachment: "fixed" }}>
                <CardBody>
                  {showProfile && (
                    <div>
                      
                      <Row>
                        <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                          <p style={{ fontSize: "18px", color: "#E40D8C" }}>
                            Profile
                          </p>
                          
                        </Col>
                        <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                          <Badge
                            color="warning"
                            style={{ fontSize: "15px" }}
                            pill
                          >
                            Verified
                          </Badge>
                        </Col>
                      </Row>
                      <Row>
                        <Col  lg="3" md="6" sm="12" xs="12">
                        <i
                            className="fas fa-user-circle"
                            style={{ fontSize: "125px", color: "#E40D8C" ,display: "none !important"}}
                          ></i>
                        </Col><Col><Button
                            className="btn btn-success"
                            // onClick={() => {
                            //   setShowProfile(false)
                            // }}
                          >
                            <i className="fas fa-edit"  style={{ display: "none !important"}}></i>
                          </Button></Col>
                      </Row>
                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">
                          {"Full Name"}
                        </p>
                      </Row>
                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">
                          {"Department"}
                        </p>
                      </Row>
                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">
                          {"Designation"}
                        </p>
                      </Row>

                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">
                          {"Mobile Number"}
                        </p>
                      </Row>

                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">
                          {"Company Email"}
                        </p>
                      </Row>
                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">{"Email"}</p>
                      </Row>
                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">
                          {"Company"}
                        </p>
                      </Row>
                      <Row className="mt-3">
                        <p className="client-detail-grid-heading">{"Branch"}</p>
                      </Row>
                    </div>
                  )}
                  {editprofile && (
                    <div>
                      <Row>
                        <p style={{ fontSize: "15px", color: "#E40D8C" }}>
                          Edit Profile
                        </p>
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Full Name"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Department"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Designation"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Mobile Number"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Company Email"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Email"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Company"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Branch"}
                        </Label>
                        <Input
                          type="text"
                          placeholder=""
                          name=""
                          value={""}
                          onChange={(e) => e}
                        />
                      </Row>
                      <Row className="mt-3">
                        <Col>
                          <Button
                            type="submit"
                            onClick={() => {
                              setEditProfile(false)
                              setShowProfile(true)
                            }}
                            className="btn btn-success buttons"
                          >
                            Submit
                          </Button>
                          <Button
                            onClick={() => {
                              setEditProfile(false)
                              setShowProfile(true)
                            }}
                            className="btn btn-danger"
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
            <Col lg="9" md="9" sm="12" xs="12" className="mt-3">
              <Card>
                <CardBody>
                  <Col>
                    <Nav className="nav-tabs-custom nav-justified">
                      {(tabs || []).map((tab, tabIndex) => {
                        return (
                          <NavItem key={tabIndex}>
                            <NavLink
                              style={
                                tab && customIconActiveTab !== tab.id
                                  ? {
                                      cursor: "pointer",
                                      color: "#ABABAB",
                                    }
                                  : {
                                      cursor: "pointer",
                                    }
                              }
                              className={classnames({
                                active: tab && customIconActiveTab === tab.id,
                              })}
                              onClick={() => {
                                setCustomIconActiveTab(tab && tab.id)
                              }}
                            >
                              <span
                                className="tabs-content d-none d-sm-block"
                                style={{ marginLeft: "60px" }}
                              >
                                {tab.label}
                              </span>
                            </NavLink>
                          </NavItem>
                        )
                      })}
                    </Nav>
                  </Col>
                  {customIconActiveTab === 1 && (
                    <div>
                      <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label
                            className={"form-label"}
                            htmlFor={"Delegation Status"}
                          >
                            {"Gender"}
                          </Label>

                          <Select
                            type="text"
                            name=""
                            value={Gender}
                          onChange={(e) => setGender(e)}
                            options={[
                              { value: "male", label: "Male" },
                              { value: "female", label: "Female" },
                            ]}
                            placeholder="Select Gender"
                            classNamePrefix="select2-selection"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Alternate Phone Number"}
                          </Label>

                          <Input
                            type="mobile"
                            validation="mobile"
                            placeholder="Enter Alternate Phone Number"
                            name=""
                            pattern="[0-9]"
                            value={profileData.Alternate}
                          onChange={(e) => handleChange(e.target.value)}
                            
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Marital Status"}
                          </Label>
                          <Select
                            type="text"
                            name=""
                            value={Marital}
                          onChange={(e) => setMarital(e)}
                            
                            options={[
                              { value: "single", label: "Single" },
                              { value: "married", label: "Married" },
                            ]}
                            placeholder="Select Marital Status"
                            classNamePrefix="select2-selection"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mt-3">
                          <div style={{ display: "flex" }}>
                            <p className="client-detail-grid-heading">
                              {"Communication Options"}
                            </p>
                            <i
                              className="fa fa-plus"
                              style={{ color: "#E40D8C", marginLeft: "10px" }}
                            ></i>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Business Phone"}
                          </Label>

                          <Input
                            type="mobile"
                            validation="mobile"
                            placeholder="Enter Bussiness Phone"
                            name=""
                            pattern="[0-9]"
                            value={Business}
                            onChange={(e) => setBusiness(e.target.value)}
                              
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Mobile Phone"}
                          </Label>

                          <Input
                            type="mobile"
                            validation="mobile"
                            placeholder="Enter Mobile Phone"
                            name=""
                            pattern="[0-9]"
                            value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                            
                          />
                        </Col>

                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Skype"}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Enter Skype"
                            name=""
                            value={Skype}
                          onChange={(e) => setSkype(e.target.value)}
                            
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            <Label className="form-label" htmlFor={"From Date"}>
                              {"Email"}
                            </Label>
                          </div>
                          <Input
                            type="email"
                            placeholder="Enter Email"
                            name=""
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                              
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mt-3">
                          <p className="client-detail-grid-heading">
                            {"Company Details"}{" "}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Employee Type"}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Enter Employee Type"
                            name=""
                            value={Employee}
                            onChange={(e) => setEmployee(e.target.value)}
                              
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Role"}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Enter Role"
                            name=""
                            value={Role}
                            onChange={(e) => setRole(e.target.value)}
                              
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Biometric Code"}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Enter Biometric Code"
                            name=""
                            value={Biometric}
                            onChange={(e) => setBiometric(e.target.value)}
                              
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Training Branch"}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Enter Training Brenach"
                            name=""
                            value={Training}
                          onChange={(e) => setTraining(e.target.value)}
                            
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"DOJ"}
                          </Label>

                          <Input
                            type="date"
                            placeholder="Enter DOJ"
                            name=""
                            value={doj}
                            onChange={(e) =>setDoj (e.target.value)}
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Gross Salary"}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Enter Gross Salery"
                            name=""
                            value={Salery}
                          onChange={(e) => setSalery(e.target.value)}
                            
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Time Shift"}
                          </Label>

                          <Input
                            type="text"
                            placeholder="Enter Time Shift"
                            name=""
                            value={Shift}
                          onChange={(e) => setShift(e.target.value)}
                            
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mt-3">
                          <p className="client-detail-grid-heading">
                            {"Address"}{" "}
                          </p>
                        </Col>
                      </Row>

                      <BootstrapTable
                        keyField="_id"
                        data={""}
                        columns={columns}
                        striped
                      />
                      <Row>
                        <Col className="mt-3">
                          <p className="client-detail-grid-heading">
                            {"Shared Employee"}{" "}
                          </p>
                        </Col>
                      </Row>
                      <BootstrapTable
                        keyField="_id"
                        data={""}
                        columns={column}
                        striped
                      />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default MyProfile
